import React, { createContext, useContext, useEffect, useReducer } from 'react'
import { getActionHistoryWrapWithKey } from './utils'
const actionHistoryWrap = getActionHistoryWrapWithKey('controls')
export const ControlContext = createContext(null)
export const ControlActionHistoryContext = createContext(null)
export const ControlReducerContext = createContext(null)

export function ControlProvider({
  children,
  data,
  // onChange = () => { }
}) {
  const [{controls, actionHistory}, dispatch] = useReducer(controlReducer, { controls: data || [], actionHistory:[] })



  useEffect(()=>{
    if(data){
      console.log('initializing controls', data)
      dispatch({type:'_init', controls: data || []})
    }
  }, [data])

  // console.log('passing this down', state)
  return (
    <ControlContext.Provider value={controls}>
      <ControlActionHistoryContext.Provider value={actionHistory}>
        <ControlReducerContext.Provider value={dispatch}>
          {children}
        </ControlReducerContext.Provider>
      </ControlActionHistoryContext.Provider>
    </ControlContext.Provider>
  )
}

export function useControl() {
  return useContext(ControlContext)
}

export function useControlActionHistory(){
  return useContext(ControlActionHistoryContext)
}

export function useControlReducer() {
  return useContext(ControlReducerContext)
}

function controlReducer(state, action) {
  const { controls, actionHistory } = state
  console.log('controls and action', controls, action)

  switch (action.type) {
    case 'clear_all':
      let newControlContent = {}
      for (let key in controls) newControlContent[key] = ''
      return actionHistoryWrap([
        ...controls.slice(0, action.idx),
        newControlContent,
        ...controls.slice(action.idx + 1, controls.length)

      ], actionHistory, action)
    case 'clear_by_keys':
      let newControls = { ...controls }
      for (let keyToClear of action.keys) newControls[keyToClear] = ''

      return actionHistoryWrap([
        ...controls.slice(0, action.idx),
        newControls,
        ...controls.slice(action.idx + 1, controls.length)

      ], actionHistory, action)
    case '_init':
      return actionHistoryWrap(action.controls, actionHistory, action)
    // case 'changed':
    //   let idx = action.idx || 0
    //   return actionHistoryWrap([
    //     ...controls.slice(0, idx),
    //     {
    //       ...controls[idx],
    //       [action.name]: action.value
    //     },
    //     ...controls.slice(idx + 1, controls.length)

    //   ], actionHistory, action)
    case 'changed':
      return actionHistoryWrap([
        ...controls.slice(0, action.idx),
        {
          ...controls[action.idx],
          ...action.update
        },
        ...controls.slice(action.idx + 1, controls.length)

      ], actionHistory, action)
    case 'set_full_controls':
      return actionHistoryWrap([
        ...action.controls
      ], actionHistory, action)
    case 'add_blocks':
      return actionHistoryWrap([...controls, ...action.blocks], actionHistory, action)
    case 'sort_blocks':
      if(!action.sortFn) return actionHistoryWrap([...controls].sort((a, b)=>a._id > b._id ? -1 : 1), actionHistory, action)
      return actionHistoryWrap([...controls].sort(action.sortFn), actionHistory, action)
    case 'delete_block':
      let action_idx = action.idx || controls.findIndex(block=>block._id === action.file._id)
      return actionHistoryWrap([
        ...controls.slice(0, action_idx),
        ...controls.slice(action_idx+1)
      ], actionHistory, {...action, idx:action_idx})

    default:
      return actionHistoryWrap(controls, actionHistory, action)
  }
}
